export default "__VITE_ASSET__8d16a51b__"